import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { white } from 'styles/colors'
import { header1, title } from 'styles/texts'
import {
  profilePictureSelector,
  fullNameSelector,
  employerSelector,
  titlesSelector,
} from 'selectors'

import ProfilePicture from 'components/ProfilePicture'

const Wrapper = styled.div`
  padding: 30px;
  background-color: ${white};
  border-radius: 6px;
  width: 290px;
  margin: 20px auto;
  position: relative;
`

const Name = styled.div`
  ${header1};
  margin-top: 20px;
  display: flex;
`

const Employer = styled.div`
  ${title};
  margin-bottom: 10px;
`

const Titles = styled.div`
  ${title};
`

const User = ({ profilePicture, name, employer, titles }) => (
  <Wrapper>
    <ProfilePicture src={profilePicture} size={60} />
    <Name>{name}</Name>
    <Employer>{employer}</Employer>
    <Titles>{titles.join(', ')}</Titles>
  </Wrapper>
)

const mapStateToProps = (state, { userId }) => ({
  profilePicture: profilePictureSelector(state, userId),
  name: fullNameSelector(state, userId),
  employer: employerSelector(state, userId),
  titles: titlesSelector(state, userId) || [],
})

export default connect(mapStateToProps)(User)



// WEBPACK FOOTER //
// ./src/components/User.js